import type {AriaController} from '@wandb/forge-shell-contract/aria';
import {createContext, useContext} from 'react';

export const unavailableActionResult = () =>
  ({ok: false, reason: 'unavailable'}) as const;
const unavailable = unavailableActionResult;
const noop = () => {};
const unavailableController: AriaController = {
  isAvailable: false,
  startChat: unavailable,
  openChat: noop,
  openChatToThread: noop,
  registerExternalTurn: noop,
  subscribeExternalTurnCreated: () => noop,
  observeThreadAsRead: () => noop,
  markThreadRead: noop,
};

/**
 * NonLocalAriaController overrides the module-global local controller store
 * with a controller supplied by a host such as the Forge shell.
 *
 * undefined: no override; standalone W&B (and older shells) use the local
 * store. null: the host owns Aria but has no registered controller yet, so
 * actions report unavailable instead of falling back to the local store.
 */
export const NonLocalAriaController = createContext<
  AriaController | null | undefined
>(undefined);

export function useNonLocalAriaController() {
  const controller = useContext(NonLocalAriaController);
  return controller === null ? unavailableController : controller;
}
